import { _get, _post } from "./Axios";

export default class PenilaianKpiApi {
  static get(id = null) {
    if (id == null) {
      return _get("penilaian");
    } else {
      return _get("penilaian/" + id);
    }
  }
  
  static getList(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("penilaian?" + params);
  }

  static getDetailPenilaianKinerja(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("penilaian/realisasi-kinerja?" + params);
  }

  static getDetailPenugasanKhusus(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("realisasi/penugasan-khusus?" + params);
  }

  static getDetailPengurangan(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("realisasi/pengurangan?" + params);
  }

  static getDetailKompetensi(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("realisasi/kompetensi?" + params);
  }
  
  static checkLimitInput(data) {
    return _post("realisasi/kompetensi/limit", data);
  }
  
  static addKompetensi(data) {
    return _post("realisasi/kompetensi", data);
  }
  
  static getPenilaianAkhir(data) {
    return _post("penilaian/akhir", data);
  }
  
  static submitKeputusan(data) {
    return _post("penilaian/akhir/keputusan", data);
  }
  
  static addNotePenilaianKinerja(data) {
    return _post("penilaian/realisasi-kinerja/catatan", data);
  }
  
  static addNotePenugasanKhusus(data) {
    return _post("penilaian/penugasan-khusus/catatan", data);
  }
  
  static addNotePengurangan(data) {
    return _post("penilaian/pengurangan/catatan", data);
  }
  
  static addNoteKompetensi(data) {
    return _post("realisasi/kompetensi/catatan", data);
  }
  
  static addNotePenilaianAkhir(data) {
    return _post("penilaian/akhir/catatan", data);
  }

  // static update(id, data) {
  //   return _post("penilaian/" + id, data);
  // }
  // static delete(id) {
  //   return _delete("penilaian/" + id);
  // }
}
